import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import './DiscountBar.css';

import { CONTENT, DOWNLOAD_LINKS } from '../config/landingPageContent';

const DiscountBar = ({ enabled, variant = 'default' }) => {
  const content = CONTENT[variant] || CONTENT.default;
  const [isVisible, setIsVisible] = useState(true);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  // Function to calculate time remaining until end of current day
  const calculateTimeUntilEndOfDay = () => {
    const now = new Date();
    const endOfDay = new Date(now);
    endOfDay.setHours(23, 59, 59, 999); // Set to end of current day
    
    const timeDiff = endOfDay - now;
    
    if (timeDiff <= 0) {
      // If we're past end of day, return 0
      return { hours: 0, minutes: 0, seconds: 0 };
    }
    
    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
    
    return { hours, minutes, seconds };
  };

  useEffect(() => {
    // Mobile detection
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPhone|iPad|iPod|Android/i.test(userAgent)) {
      setIsMobile(true);
    }

    // Set initial time
    setTimeLeft(calculateTimeUntilEndOfDay());
    
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeUntilEndOfDay());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleCodeButtonClick = () => {
    setShowDownloadPopup(true);
  };

  const handleDownloadClick = () => {
    if (isMobile) {
      alert('This download is only available for macOS. Please visit this page on a macOS device to download.');
    } else {
      window.location.href = DOWNLOAD_LINKS.appleSilicon;
    }
    setShowDownloadPopup(false);
  };

  const handleClosePopup = () => {
    setShowDownloadPopup(false);
  };

  if (!isVisible || !enabled) {
    return null;
  }

  return (
    <>
      <div className="discount-bar">
        <div className="discount-decorative">
          <div className="diamond diamond-large"></div>
          <div className="diamond diamond-small"></div>
        </div>
        
        <div className="discount-content">
          <div className="discount-text">
            <h2 className="discount-title">⚡ Secure your offer: 25% OFF - ENDS SOON!</h2>
            <p className="discount-subtitle"> {content.discount.subtitle}</p>
          </div>
          
          <div className="discount-actions">
            <div className="countdown-timer">
              <div className="time-unit">
                <span className="time-number">{timeLeft.hours.toString().padStart(2, '0')}</span>
                <span className="time-label">HRS</span>
              </div>
              <div className="time-separator">:</div>
              <div className="time-unit">
                <span className="time-number">{timeLeft.minutes.toString().padStart(2, '0')}</span>
                <span className="time-label">MIN</span>
              </div>
              <div className="time-separator">:</div>
              <div className="time-unit">
                <span className="time-number">{timeLeft.seconds.toString().padStart(2, '0')}</span>
                <span className="time-label">SEC</span>
              </div>
            </div>
            
            <button className="discount-code-button" onClick={handleCodeButtonClick}>
              Use code ONSITE25
            </button>
          </div>
        </div>
        
        <button className="close-button" onClick={handleClose}>
          <X size={16} />
        </button>
      </div>

      {/* Download Popup */}
      {showDownloadPopup && (
        <div className="download-popup-overlay">
          <div className="download-popup">
            <button className="popup-close-button" onClick={handleClosePopup}>
              <X size={20} />
            </button>
            <div className="popup-content">
              <h3 className="popup-title">🎉 Congratulations!</h3>
              <p className="popup-message">
                You've secured your 25% discount with code <strong>ONSITE25</strong>!
              </p>
              <p className="popup-submessage">
                {content.discount.footer}
              </p>
              <div className="popup-actions">
                <button className="popup-download-button" onClick={handleDownloadClick}>
                  <svg className="download-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                  </svg>
                  Download Now
                </button>
                <button className="popup-cancel-button" onClick={handleClosePopup}>
                  Maybe Later
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DiscountBar;
